import { useEffect, useState } from "react";
import { t } from "i18next";
import { useHistory } from "react-router-dom";
import { Table, Typography } from "antd";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import Helper from "../../../core/Helper";
import { PERMISSIONS, useUser } from "../../../core/context/UserContext";
import ApiService from "../../../core/service/ApiService";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import ExpenseFilter from "./ExpenseFilter";

const SummaryRow = () => {
    const { queryModel } = useDataGrid();
    const [summaries, setSummaries] = useState([]);

    const load = async () => {
        const res = await ApiService.Expense.GetExpenseGridSummary({
            ...queryModel.filter,
            startDate: queryModel.filter.startDate.clone().startOf('day').utc().format('yyyy-MM-DDTHH:mm:ss+00:00'),
            endDate: queryModel.filter.endDate.clone().endOf('day').utc().format('yyyy-MM-DDTHH:mm:ss+00:00'),
        });
        if (res.success) {
            setSummaries(res.data)
        }
    }

    useEffect(() => {
        load()
    }, [queryModel.updateKey])

    return (
        <Table.Summary>
            <Table.Summary.Row>
                <Table.Summary.Cell colSpan={3}>
                    <Typography.Text strong={true}>
                        {t('Total')}:
                    </Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={2}>
                    <table>
                        {
                            summaries.map((item, index) => (
                                <tr>
                                    <td>
                                        <b>{Helper.Currency.format(item.amount, { currency: item.currency })}</b>
                                    </td>
                                </tr>
                            ))
                        }
                    </table>
                </Table.Summary.Cell>
            </Table.Summary.Row>
        </Table.Summary>
    )
}

export default function ExpenseGrid() {
    const history = useHistory();
    const { queryModel, setData, setPaginationResult, setDataGridProps, refreshDataGrid } = useDataGrid();
    const { hasPermission } = useUser()

    const load = async () => {
        const res = await ApiService.Expense.GetExpenseDataGrid({
            ...queryModel,
            filter: {
                ...queryModel.filter,
                startDate: Helper.Date.beginOfDay(queryModel.filter.startDate),
                endDate: Helper.Date.endOfDay(queryModel.filter.endDate),
            }
        });
        if (res.success) {
            setData(res.data);
            setPaginationResult(res.pagination)
        }
    }

    useEffect(() => {
        load()
    }, [queryModel.updateKey])

    const deleteExpense = async (expenseId) => {
        const res = await ApiService.Expense.DeleteExpense(expenseId);
        if (res.success) {
            refreshDataGrid()
        }
    }

    const renderAction = (row) => {
        return (
            <div
                style={{ display: 'flex', gap: 8 }}
            >
                {hasPermission(PERMISSIONS.APPOINTMENT_CREATE_EDIT) && <a onClick={() => history.push(`/app/expenses/edit/${row.id}`)}>{t('Edit')}</a>}
                {hasPermission(PERMISSIONS.EXPENSE_DELETE) && <a onClick={() => deleteExpense(row.id)} className={'text-danger'}>{t('Delete')}</a>}
            </div>
        )
    }

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: [
                { dataIndex: 'date', key: 'date', title: t('Date'), sorter: true, render: (text, row) => Helper.Date.dateFormat(text) },
                { dataIndex: 'cashRegister', key: 'cashRegister', title: t('Cash Register'), sorter: true, render: (text, row) => row?.cashRegister?.name },
                { dataIndex: 'description', key: 'Description', title: t('Description') },
                { dataIndex: 'amount', key: 'amount', title: t('Amount'), render: (text, row) => Helper.Currency.format(text, { currency: row.currency }) },
                { dataIndex: '#', key: '#', title: t('#'), render: (text, row) => renderAction(row) },
            ],
            antdTableProps: {
                summary: () => <SummaryRow />
            }
        })
    }, [])

    return (
        <>
            <DataGrid
                title={() => {
                    return (
                        <ExpenseFilter />
                    )
                }}
            />
        </>
    )
}
